import React from 'react';
import NalogAdmin from './NalogAdmin';
import InventuraAdmin from './Inventura';

const AdminDashboard = () => {
  return (
    <div>
      <h1>Admin Dashboard</h1>
      <NalogAdmin />
      <InventuraAdmin />
    </div>
  );
};

export default AdminDashboard;